module.exports = __webpack_public_path__ + "static/img/Joey-Manu.e33e594.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Joey-Manu.jpg
// module id = x54X
// module chunks = 0